import { ReactNode } from 'react';

type InputFormSectionProps = {
  children: ReactNode;
  isDisabled: boolean;
  error?: string;
  isSubmitSuccessful: boolean;
};

export function InputFormSection({ children, isDisabled, error, isSubmitSuccessful }: InputFormSectionProps) {
  if (isSubmitSuccessful)
    return (
      <InputFormContainer>
        <span className="py-2 text-center font-semibold">
          ¡Gracias por completar el formulario! Nos pondremos en contacto contigo a la brevedad.
        </span>
      </InputFormContainer>
    );
  return (
    <InputFormContainer>
      {children}
      {error && <span className="text-errorColor text-xs py-2">{error}</span>}
      <button
        type="submit"
        className={`p-2 rounded-lg font-semibold shadow-lg hover:bg-primary/85 text-white ${!isDisabled ? 'bg-primary' : 'bg-gray-300'}`}
        disabled={isDisabled}
      >
        {isDisabled ? 'Enviando...' : 'Enviar'}
      </button>
    </InputFormContainer>
  );
}

export function InputFormContainer({ children }: { children: ReactNode }) {
  return <div className="flex flex-col w-full p-4 space-y-4 border rounded-lg">{children}</div>;
}
